<script>
    import Stroke from "./Stroke.svelte";
    import {createEventDispatcher} from "svelte";
    import Color from "./Color.svelte";

    export let style;

    $: stroke = style.stroke;
    $: fill = style.fill;
    $: fillColor = fill.color;

    $: console.log(fill);

    const dispatch = createEventDispatcher();

    function onChange(changed) {
        console.log(changed);
        const newStyle = {
            fill: {
                ...fill,
            },
            stroke: {
                ...stroke
            },
            ...changed
        }

        dispatch('changeStyle', newStyle)
    }

    const changeFill = ev => {
        const color = ev.detail;
        onChange({ fill: { ...fill, color }});
    };
</script>

<h5>Border</h5>
<Stroke {stroke} on:changeStyle={(e) => onChange(e.detail)} min={0}/>

<h5>Fill</h5>
<Color color={fillColor} on:changeColor={changeFill} />



